<template>
  <v-sheet color="white" elevation="5" rounded class="mt-5 mb-5 pt-3 pb-5 pl-3 pr-3">
    <div class="profile-content">
      <h4 class="d-flex justify-space-between">
        <span>Litter #{{ litterId }}</span>
        <span>Registered on <localized-date :date="litterInfo.registrationDate" /></span>
      </h4>   
      <h1 class="mb-5">
        Litter whelped on <localized-date :date="litterInfo.whelpingDate" />
      </h1>
      <v-row>
        <v-col cols="12" sm="6">
          <h2 class="blue-grey--text text--darken-1">Dam:</h2>
          <v-row class="mt-5">
            <v-col cols="2">
              <v-img
                :src="defaultImage"
                class="profile-picture"
                min-width="40px"
                max-width="40px"
                contain
              />
            </v-col>
            <v-col cols="10">
              <h4>
                <b>{{ litterInfo.dam.name }}</b>
              </h4>
              <span
                >{{ litterInfo.dam.ascaId }} • {{ litterInfo.dam.mainColor }} •
                {{ litterInfo.dam.dnaStatus }}</span
              >
            </v-col>
          </v-row>
          <v-row>
            <p class="ml-3">
              <span v-for="(co, i) in litterInfo.dam.owners" :key="i">
                <b>{{ co.isPrimary ? "Primary Owner" : "CoOwner" }}: </b>
                {{ co.firstName }}
                {{ co.lastName }}
                <span v-if="co.memberId">(Member: {{co.memberId}})</span>
                <br />
              </span>
            </p>
          </v-row>
        </v-col>
        <v-divider vertical light class="d-none d-sm-flex"></v-divider>
        <v-col cols="12" sm="6">
          <h2 class="blue-grey--text text--darken-1">Sire:</h2>
          <v-row class="mt-5">
            <v-col cols="2">
              <v-img
                :src="defaultImage"
                class="profile-picture"
                min-width="40px"
                max-width="40px"
                contain
              />
            </v-col>
            <v-col cols="10">
              <h4>
                <b>{{ litterInfo.sire.name }}</b>
              </h4>
              <span>
                {{ litterInfo.sire.ascaId }} •
                {{ litterInfo.sire.mainColor }} •
                {{ litterInfo.sire.dnaStatus }}
              </span>
            </v-col>
          </v-row>
          <v-row>
            <p class="ml-3">
              <span v-for="(co, i) in litterInfo.sire.owners" :key="i">
                <b>{{ co.isPrimary ? "Primary Owner" : "CoOwner" }}:</b>
                {{ co.firstName }}
                {{ co.lastName }}
                <span v-if="co.memberId">(Member: {{co.memberId}})</span>
                <br />
              </span>
            </p>
          </v-row>
        </v-col>
      </v-row>
      <br/>
      <v-row class="mt-3">
        <v-col cols="12" sm="6">
          <h2 class="blue-grey--text text--darken-1">Litter Owners:</h2>
          <v-row class="mt-5">
            <p class="ml-3">
              <span v-for="(co, i) in litterInfo.owners" :key="i">
                <b>{{ co.isPrimary ? "Primary Owner" : "CoOwner" }}:</b>
                {{ co.firstName }}
                {{ co.lastName }}
                <span v-if="co.memberId">(Member: {{co.memberId}})</span>
                <br />
              </span>
            </p>
          </v-row>
        </v-col>
        <v-divider vertical light class="d-none d-sm-flex"></v-divider>
        <v-col cols="12" sm="6">
          <h2 class="blue-grey--text text--darken-1">Associated Kennels:</h2>
          <v-row class="mt-5">
            <p class="ml-3">
              <span v-for="k in litterInfo.kennels" :key="k.id">
                {{ k.name }} - {{ k.id }}
                <br />
              </span>
              <span v-if="!litterInfo.kennels.length">None</span>
            </p>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h2 class="blue-grey--text text--darken-1 mb-4">Puppies:</h2>
          <v-row>
          <v-col>
            <v-alert type="info" v-if="litterInfo.puppies.some(p => p.canBeRegistered || p.canBeReleased)">
              <p>REGISTER: This is the process for litter owners retaining ownership of the selected puppy.</p>
              <p>RELEASE: (Coming soon!) This is the process for transferring ownership of the puppy after sale.<br/>
                      Please, use the paper forms, while we're working on making it available online. <br/>
                      Thank you for your patience.
              </p>
            </v-alert>
          </v-col>
        </v-row>    
          <v-data-table
            :headers="headers"
            :items="litterInfo.puppies"
            class="elevation-1 full-width"
            hide-default-footer
          >
            <template v-slot:[`item.dogId`]="{ item }">
              <router-link :to="`/dogs/${encodeURIComponent(item.dogId?.trim())}`" target="_blank">
                {{ item.dogId?.trim() }}
              </router-link>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <router-link
                class="no-text-decoration"
                :to="`/litters/${litterId}/register/${item.id}`"
                v-if="item.canBeRegistered">
                <v-btn class="mr-4"> 
                  Register
                  <v-tooltip dark right>
                    <template v-slot:activator="{on, attrs}">
                      <font-awesome-icon
                        icon="info-circle"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      />&nbsp;
                    </template>
                    <span>
                      &nbsp;This is the process for litter owners retaining ownership of the selected puppy.
                    </span>
                  </v-tooltip>
                </v-btn>
              </router-link>

             <!--<router-link v-if="item.canBeReleased" :disabled="true" class="no-text-decoration" :to="`/litters/${litterId}/release/${item.id}`"">-->
                
                  <v-tooltip dark right v-if="item.canBeReleased" >
                    <template v-slot:activator="{on, attrs}">
                      <font-awesome-icon
                        icon="info-circle"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      />&nbsp;
                      <v-btn v-if="item.canBeReleased" :disabled="true">
                        Release
                      </v-btn>
                    </template>
                    <span>
                      &nbsp;Coming soon! This is the process for transferring ownership of the puppy after sale.<br/>
                      Please, use the paper forms, while we're working on making it available online. <br/>
                      Thank you for your patience.
                    </span>
                  </v-tooltip>
              <!--</router-link>-->
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import litterService from "@/services/portal/litterService";
import { UserInfo } from "@/types/User";

const defaultImage = require('@/assets/photouploadblue.png');

export default Vue.extend({
  name: "LitterInfo",
  data: function () {
    return {
      defaultImage,
      litterInfo: {
        dam: {
          name: "",
          owners: [],
        },
        sire: {
          name: "",
          owners: [],
        },
        owners: [],
        kennels: [],
        puppies: [],
      },
      headers: [
        { text: "Puppy ID", value: "id" },
        { text: "Sex", value: "gender" },
        { text: "Main Color", value: "mainColor" },
        { text: "Is Dead/Culled", value: "isDead" },
        { text: "Dog ID#", value: "dogId" },
        { text: "Breeder Notes", value: "notes" },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  methods: {},
  created: function () {
    if (this.litterId) {
      litterService
        .getLitterById(this.litterId)
        .then((res) => {
          this.litterInfo = res;
        })
        .catch(this.$handleError);
    }
  },
  watch: {
    litterId: function (newVal: String) {
      litterService
        .getLitterById(this.litterId)
        .then((res) => {
          this.litterInfo = res;
        })
        .catch(this.$handleError);
    },
  },
  props: {
    litterId: { type: Number },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
</script>
